export const DEFAULT_LOCALE_STATE = {
	locale: 'en',
	messages: {},
};
